<article
    [routerLink]="payRoute"
    class="group relative flex cursor-pointer flex-col gap-4 rounded-lg border border-border bg-surface px-5 py-4 shadow-xs transition-all duration-fast ease-standard hover:border-border-strong hover:shadow-md has-[:focus-visible]:border-brand has-[:focus-visible]:shadow-ring-brand">
    <header class="flex items-start justify-between gap-4">
        <div class="flex min-w-0 items-center gap-3">
            <span class="grid size-8 shrink-0 place-items-center rounded-sm bg-brand-tint text-brand">
                <i class="ph ph-fill ph-storefront text-base" aria-hidden="true"></i>
            </span>
            <h3 class="m-0 truncate font-display text-lg font-semibold text-text">{{ venue().name }}</h3>
        </div>

        <p-tag [value]="status().label" [severity]="status().severity" [rounded]="true" />
    </header>

    @if (sharedFrom(); as source) {
    <p class="m-0 -mt-2 flex items-center gap-1.5 text-xs text-text-muted">
        <i class="ph ph-link" aria-hidden="true"></i>
        Shares FunPay account with {{ source }}
    </p>
    }

    <ul class="m-0 flex list-none flex-col gap-3 p-0 text-sm">
        @let paymentsActive = paymentEnabled(); @let deposits = depostisEnabled();
        <li class="flex items-center gap-3">
            <i
                class="ph ph-fill ph-credit-card shrink-0 text-base"
                [ngClass]="paymentsActive ? 'text-paid' : 'text-text-muted'"
                aria-hidden="true"></i>
            <span class="text-text-2">Payments</span>
            @if (paymentsActive) {
            <span class="ml-auto font-medium text-text">{{ venue().settings?.paymentSettings?.paymentProvider }}</span>
            } @else {
            <span class="ml-auto text-text-muted">Not enabled</span>
            }
        </li>

        <li class="flex items-center gap-3">
            <i
                class="ph ph-fill ph-piggy-bank shrink-0 text-base"
                [ngClass]="deposits ? 'text-paid' : 'text-text-muted'"
                aria-hidden="true"></i>
            <span class="text-text-2">Deposit</span>
            <span class="ml-auto flex items-center gap-2" [ngClass]="deposits ? 'text-paid' : 'text-text-muted'">
                {{ deposits ? 'Enabled' : 'Disabled' }}
                <i [ngClass]="deposits ? 'ph-fill ph-check-circle' : 'ph ph-minus-circle'" class="text-base" aria-hidden="true"></i>
            </span>
        </li>
    </ul>

    <footer class="flex min-h-8 items-center justify-between gap-3 border-t border-border pt-3">
        <span class="flex items-center gap-2 text-sm text-text group-hover:text-brand! transition-all">
            <i class="ph ph-fill ph-sparkle text-text group-hover:text-brand!" aria-hidden="true"></i>
            Get lower rates and smoother payments now!
        </span>

        @if (hasFunPay() || isFunpayLive()) {
        <button
            pButton
            type="button"
            size="small"
            [text]="true"
            class="static! overflow-visible! after:absolute after:inset-0 after:content-['']"
            [attr.aria-label]="'View FunPay account for ' + venue().name">
            <i class="ph ph-arrow-square-out" aria-hidden="true"></i>
            <span>View account</span>
        </button>
        } @else {
        <button
            pButton
            type="button"
            size="small"
            [outlined]="true"
            class="static! overflow-visible! after:absolute after:inset-0 after:content-['']"
            [attr.aria-label]="'Apply to FunPay for ' + venue().name">
            <i class="ph ph-paper-plane-tilt" aria-hidden="true"></i>
            <span>Apply to FunPay</span>
        </button>
        }
    </footer>
</article>
